<template>
<div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Baja de embarcacion</h4>
            <p>Realiza la baja de una embarcacion con su respectiva justificación </p>       
        </div>
    </div>
    
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#search-ship" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Busqueda Embarcación</a>
        </div>
    </nav>
            
    <div class="tab-content" id="nav-tabContent">                

        <div class="tab-pane fade show active" id="search-ship" role="tabpanel" aria-labelledby="nav-new-tab" >
            <br>
                    
                    <h6 align="center">Busqueda y Seleccion de Embarcacion/Nave/Artefacto Naval</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="ship_select.id > 0" class="panel panel-default">

                        <div class="form-row">
                            <div class="form-group col-12 col-md-4">
                                <label for="type_identification" class="badge badge-primary">Nombre Embarcación</label>
                                <input type="text" name="name_owner" id="name_owner" readonly class="form-control-plaintext" :value="ship_select.name_boat">
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="number_identification" class="badge badge-primary">Matricula </label>
                                <input type="text" class="form-control-plaintext" :value="ship_select.enrollment_old" name="number_identification" readonly>
                            </div>

                            <div class="form-group col-12 col-md-4">
                                <label for="site_expedition" class="badge badge-primary">TRB </label>
                                <input type="text" class="form-control-plaintext" :value="ship_select.trb" name="number_identification" readonly>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12">
                                <textarea class="form-control" name="description_down" id="description_down" v-model="description_down" cols="30" rows="4" autocomplete="off" placeholder="DESCRIPCION DE LA BAJA"></textarea>
                            </div>
                        </div>

                        <button class="btn btn-success col-12 col-md-2 offset-md-3" @click="mSaveDown"><font-awesome-icon icon="save" size="2x" /></button>
                        <button class="btn btn-outline-primary col-12 col-md-2" @click="mCallPrint(ship_select.id)"><font-awesome-icon icon="print" size="2x" /></button>
                        <button class="btn btn-danger col-12 col-md-2 " @click="mCloseSelectShip"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mViewSearchShip">
                                <input class="form-check-input" type="radio" name="radiosShip" id="radiosShip1" v-model="optionSearchShip"  value="enrollment" checked> Nombre 
                            </label>
                            <label class="btn btn-success" @click="mViewSearchShip">
                                <input class="form-check-input" type="radio" name="radiosShip" id="radiosShip2" v-model="optionSearchShip" value="name">Matricula
                            </label>
                        </div>

                        <div class="form-group"> 
                            <label for="nombrePersona">{{ searchTypeShip }}</label>
                            <input type="text" class="form-control" id="data_person" v-model="data_ship" :placeholder="searchTypeShip" autocomplete="off">
                            <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypeShip }} </small>
                        </div>
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaDataShip">Buscar</button>

                        <div class="table-responsive" v-if="list_ship_select.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre</th>
                                        <th>MATRICULA</th>
                                        <th>ESTADO</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                        <th><font-awesome-icon icon="print"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(shipSelc, index) in list_ship_select" :key="shipSelc.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ shipSelc.name_boat }}</span>
                                        </td>
                                        <td>{{ shipSelc.enrollment_old }}</td>

                                        <td v-if="shipSelc.vigencia_matricula === 'A'" class="alert alert-success" align="center">ACTIVO</td>
                                        <td v-else-if="shipSelc.vigencia_matricula === 'V'" class="alert alert-warning" align="center">VENCIDO</td>
                                        <td v-else class="alert alert-danger" align="center">BAJA</td>

                                        <td v-if="shipSelc.vigencia_matricula !== 'I'" align="center">
                                            <button class="btn btn-outline-info" @click="mSelectShipOwner(shipSelc)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>

                                        <td v-else align="center" class="alert alert-danger">
                                            <font-awesome-icon icon="check"/>
                                        </td>
                                        <td align="center"><button class="btn btn-outline-primary" @click="mCallPrint(shipSelc.id_boat)"><font-awesome-icon icon="tasks" /></button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
        </div>

    </div>
    <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
const qs = require('qs');

import modalLoading from '../modal/modalLoading';


export default {
    name:'down-ship',
    data(){
        return{
            description_transfer:null,
            ship_select:{id:0},
            list_ship_select:[],
            status_send:true,
            modal_load_id:'id_down_ship',
            modal_load_title:'Registrando', 
            optionSearchShip:'name',
            optionSearchPerson:'name',
            data_ship:null,
            optionSearch:'name',
            old_owner:{id:0},
            dts_transfer:null,
            description_down:null
        }
    },
    mounted(){
        // if(Vue.auth.getToken()){
        //     axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
        // }
        // console.log(axios.defaults.headers)
    },
    methods:{
        mCallPrint(idb){
            this.modal_load_title='Solicitando';
            this.mShowModalUP(this.modal_load_id);
            let u;
                            // u=`pdfReportBoat/${idb}`;
            u=`pdfReportBoat/${idb}?api_token=${Vue.auth.getToken()}`;
            
            axios.get(u, 
            // axios.get(`pdfReportBoat/${idb}`, 
                {
                    responseType:'blob'
                })
                .then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Reporte.pdf');
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(()=>{
                        this.mCloseModalUP(this.modal_load_id);
                    }, 1000)
                })
                .catch(err=>{
                    console.error(err)
                    toastr.error('Ocurrio un error contacte al administrador', 'Error');
                    this.mCloseModalUP(this.modal_load_id);
                })
        },
        mShowModalUP(idM){
            $('#'+idM).modal('show');
        },
        mCloseModalUP(idM){
            $('#'+idM).modal('hide');
        },
        mValidateDescriptionDown(){
            try {
                let auxDescription=this.description_down.trim();
                if(this.description_down===null || auxDescription.length===0){
                    toastr.error('Indique los documentos que sustentan la baja de la embarcación', 'Error BS-01');
                    return false;
                }
                return true;    
            } catch (error) {
                console.log('error ')
            }
            
        },
        mSaveDown(){
            if(this.mValidateDescriptionDown()){
                let message = {
                    title: 'Baja de Embarcación',
                    body: `¿Desea Registrar la Baja de la Embarcacion con Matricula <b>${this.ship_select.enrollment_old}</b>?`
                    }
                    
                    let npr=new Promise((resolve, reject)=>{
                        this.$dialog
                        .confirm(message)
                        .then(function(dialog) {
                            resolve(true);          
                        })
                        .catch(function() {
                            resolve(false);
                        });
                    });
                    
                    npr.then(async (msg)=>{
                        if(msg){
                            // subimos la fotografia
                            this.mShowModalUP(this.modal_load_id);
                            try {                                
                                let nprop={
                                    // id_person:this.person_select.id,
                                    ship:this.ship_select.id,
                                    description_down:this.description_down
                                }
                                let regOwner= await axios.post(`downShipActive?api_token=${Vue.auth.getToken()}`, qs.stringify(nprop));
                                    
                                if(regOwner.data[0].status){
                                    toastr.success(regOwner.data[0].respuesta, 'Exito');
                                    // this.mCloseSelectPerson();
                                    this.mCloseSelectShip();
                                    setTimeout(()=>{
                                        this.mCloseModalUP(this.modal_load_id);
                                        this.list_ship_select=[];
                                        this.buscaDataShip();
                                        // this.data_ship=null;
                                    }, 3000) 
                                    
                                }else{
                                    toastr.error(fd.data[0].respuesta, 'Error');
                                }                                                           

                            }catch(err){
                                console.log('error al registrar');
                                setTimeout(()=>{
                                    toastr.error('Ha ocurrido un error en el proceso', 'Error P-01')
                                    this.mCloseModalUP(this.modal_load_id);                                
                                }, 3000)
                            }

                            setTimeout(()=>{                
                                        this.mCloseModalUP(this.idModalL);
                            }, 1000)
                        }else{
                            console.log('No se guardo la ordop')
                            // console.log(this.s_pro_ordop);
                        }
                    })
            }else{
                toastr.error('Indique los documentos que sustentan la transferencia', 'Error P-01')
            }
            console.log('enviando al servidor')
        },
        mViewSearchShip(event){
            // console.log(event);
            let radios=$("input[type=radio]").parent('label');
            console.log(radios);
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            // console.log(radioV);
            this.optionSearchShip=radioV;
        },
        buscaDataShip(){
            this.list_ship_select=[];
            // console.log(`${this.optionSearch} tipo`);
            // console.log(`${this.data_person}`);
            if(this.data_ship !== null || this.data_ship.trim().length > 0 ){
                // console.log('enviando al servidor');
                axios.get(`searchNameBoatDown/${this.optionSearchShip}/${this.data_ship}?api_token=${Vue.auth.getToken()}`)                
                .then((res) => {                    
                        this.list_ship_select = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }else{
                toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
            }
        },
        mCloseSelectShip(){
            this.ship_select.id=0;
            this.ship_select.name_boat=null;
            this.ship_select.enrollment=null;
            this.ship_select.enrollment_old=null;
            this.ship_select.trb=null;
            this.ship_select.trn=null;
            this.old_owner.id=0;
            this.old_owner.name=null;
            this.old_owner.documento=null;
        },
        mSelectShipOwner(sbp){
            this.ship_select.id=sbp.id_boat;
            this.ship_select.name_boat=sbp.name_boat;
            this.ship_select.enrollment=sbp.enrollment;
            this.ship_select.enrollment_old=sbp.enrollment_old;
            this.ship_select.trb=sbp.trb;
            this.ship_select.trn=sbp.trn;
            this.old_owner.id=sbp.id_propietario;
            this.old_owner.name=sbp.nombre_propietario;
            this.old_owner.documento=sbp.dato_identificacion;
            switch(sbp.vigencia_matricula){
                case 'A':
                    this.ship_select.vigencia_matricula='ACTIVO';
                    break;
                case 'I':
                    this.ship_select.vigencia_matricula='BAJA';
                    break;
                case 'V':
                    this.ship_select.vigencia_matricula='VENCIDO';
                    break;
            }
            // this.mChangeOwnerIdentificationEdit();
        }
    },
    components:{
        'modal-loading':modalLoading
    },
    computed:{
        searchTypeShip(){
            switch(this.optionSearchShip){
                case 'name':
                    return 'Nombre de la Nave';
                break;

                case 'enrollment':
                    return 'Matricula de la Nave';
                break;
            }
        }
    },
    filters:{
        upperCase(value){
            return value.toUpperCase();
        }
    }
}
</script>

<style>
    .required-text{
        color:red; 
        font-weight:bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/matriculacion/DownShip.vue